// 登录态本地缓存 key（前缀 pkadmin_，避免与同域其他应用冲突）
const TOKEN_KEY = 'pkadmin_token'
const USER_KEY = 'pkadmin_user'
const MENU_KEY = 'pkadmin_menu'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
  localStorage.setItem(TOKEN_KEY, token || '')
}

export function removeToken () {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUserInfo () {
  const value = localStorage.getItem(USER_KEY)
  if (!value) return null
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export function setUserInfo (userInfo) {
  localStorage.setItem(USER_KEY, JSON.stringify(userInfo || {}))
}

export function removeUserInfo () {
  localStorage.removeItem(USER_KEY)
}

export function getCachedMenu () {
  const value = localStorage.getItem(MENU_KEY)
  if (!value) return []
  try {
    return JSON.parse(value)
  } catch (error) {
    return []
  }
}

export function setCachedMenu (menu) {
  localStorage.setItem(MENU_KEY, JSON.stringify(menu || []))
}

export function removeCachedMenu () {
  localStorage.removeItem(MENU_KEY)
}

// 登录明文密码（仅 sessionStorage，会话级，供首页"切换项目"重新登录换取项目凭证使用）
const PW_KEY = 'pkadmin_loginpw'
export function setLoginPw (pw) { sessionStorage.setItem(PW_KEY, pw || '') }
export function getLoginPw () { return sessionStorage.getItem(PW_KEY) }
export function removeLoginPw () { sessionStorage.removeItem(PW_KEY) }

// 清空全部登录态缓存
export function clearAuthStorage () {
  removeToken()
  removeUserInfo()
  removeCachedMenu()
  removeLoginPw()
}
